function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.405 28.377c-4.225 1.497-14.585 1.497-18.81 0l-.646 1.94a1 1 0 1 1-1.898-.633l.775-2.323c-1.769-1.528-2.687-4.058-2.811-7.527A3.001 3.001 0 0 1 3 14h1.083a6.009 6.009 0 0 1 3.572-4.524A5 5 0 1 1 17 7a6.994 6.994 0 0 1 5.75 3.006A5.002 5.002 0 0 1 27.9 14H29a3 3 0 0 1 .966 5.841c-.013.185-.03.389-.052.608a16.906 16.906 0 0 1-.604 3.158c-.471 1.57-1.163 2.854-2.14 3.743l.779 2.334a1 1 0 0 1-1.898.632l-.646-1.94zm.025-2.199a.845.845 0 0 1 .03-.02c.845-.571 1.493-1.657 1.934-3.125A14.963 14.963 0 0 0 27.947 20H4.023c.148 3.116 1.01 5.143 2.515 6.157l.032.021c2.696 1.763 16.164 1.763 18.86 0zM29 18a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2h26zM6.126 14h19.703a3.001 3.001 0 0 0-3.401-1.946l-.71.137-.352-.63A4.997 4.997 0 0 0 17 9a4.99 4.99 0 0 0-4.05 2.067l-.488.672-.75-.356A4.002 4.002 0 0 0 6.126 14zm3.642-4.996a5.997 5.997 0 0 1 2.06.28 6.991 6.991 0 0 1 3.158-1.99 3 3 0 1 0-5.218 1.71zM25 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-3 12v2h5.948L28 18h-6zm-4 0v2h2v-2h-2z"
});

var SvgCleaning = function SvgCleaning(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "152c004d1b1a1e6eb230808e90cf6240.svg";
export { SvgCleaning as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/cleaning.svg
// module id = null
// module chunks = 